import { useCallback, useEffect, useMemo, useState } from "react";
import { API, authFetch } from "@/App";
import { useFabricLibrary } from "./useFabricLibrary";
import { resolveOrderFabrics } from "./fabricUtils";

// Loads the order's "print with sheet" photos and resolves the fabrics of a CONTENT text.
export function useOrderFabrics(orderId, content, manual = "") {
  const library = useFabricLibrary();
  const [photos, setPhotos] = useState([]);

  const reload = useCallback(async () => {
    if (!orderId) { setPhotos([]); return []; }
    const res = await authFetch(`${API}/orders/${orderId}/attachments`);
    if (!res.ok) return [];
    const data = await res.json();
    const list = (data.attachments || []).filter((a) => a.print_with_sheet);
    setPhotos(list);
    return list;
  }, [orderId]);

  useEffect(() => { reload(); }, [reload]);

  const resolved = useMemo(() => resolveOrderFabrics(content, library, photos, manual), [content, library, photos, manual]);
  return { library, photos, resolved, reload };
}
